import { useState } from 'react'
import Button from '@/components/ui/Button'
import Drawer from '@/components/ui/Drawer'
import { TbMenu2 } from 'react-icons/tb'
import { PiEnvelopeSimpleLight } from 'react-icons/pi'
import Link from 'next/link'
import NavBarMenu from '../(public-pages)/componentspage/components/NavBarMenu'
// import { pathConfig } from '@/utils/categoriesConfig'


type DrawerBaseProps = {
    pathConfig?: any
}
const DrawerBase = ({ pathConfig }: DrawerBaseProps) => {
    const [isOpen, setIsOpen] = useState(false)

    const openDrawer = () => {
        setIsOpen(true)
    }

    const onDrawerClose = () => {
        setIsOpen(false)
    }

    const Footer = (
        <div className="w-full text-base leading-6 font-normal tracking-[0.2px] text-[#414141]">
            <a href="mailto:snab@marketsiz.ru">
                <div className="flex gap-[16] hover:underline">
                    <PiEnvelopeSimpleLight size={24} />
                    <span>Напишите нам</span>
                </div>
            </a>
        </div>
    )

    return (
        <div className="x">
            <Button
                className="bg-primary hover:bg-[#0D2E4F]"
                variant="solid"
                onClick={() => openDrawer()}
            >
                <TbMenu2 size={24} />
            </Button>
            <Drawer
                title="Категории"
                placement="right"
                isOpen={isOpen}
                footer={Footer}
                onClose={onDrawerClose}
                onRequestClose={onDrawerClose}
            >
                <NavBarMenu
                    pathConfig={pathConfig}
                    onItemClick={onDrawerClose}
                />
            </Drawer>
        </div>
    )
}

export default DrawerBase
